/**
 * Mini-tableau de répartition NORMAL/RATTRAPAGE × Semestres impair (S1/S3/S5)
 * et pair (S2/S4/S6). Affiché sous une grande stat-card.
 *
 * Reçoit l'objet de répartition :
 *   { NORMAL:     { impair: n, pair: n, total: n },
 *     RATTRAPAGE: { impair: n, pair: n, total: n } }
 */
import React from 'react';

export interface RepartitionDetail {
  impair: number;
  pair: number;
  total: number;
}

export interface RepartitionData {
  NORMAL?: RepartitionDetail;
  RATTRAPAGE?: RepartitionDetail;
}

interface Props {
  data?: RepartitionData;
  compact?: boolean;
}

const empty: RepartitionDetail = { impair: 0, pair: 0, total: 0 };

export const RepartitionMini: React.FC<Props> = ({ data, compact = false }) => {
  const normal = data?.NORMAL || empty;
  const rattrap = data?.RATTRAPAGE || empty;

  // Colonne "Total" volontairement omise : le total est déjà affiché en gros
  // dans la stat-card parente. Garder seulement Impair/Pair évite le débordement.
  return (
    <div className={`mt-2 text-[10px] w-full overflow-hidden ${compact ? '' : ''}`}>
      <table className="w-full table-fixed border-collapse">
        <thead>
          <tr className="text-gray-500 dark:text-gray-400">
            <th className="text-left font-medium pr-1 w-1/2"></th>
            <th className="text-right font-medium px-1 w-1/4">Imp</th>
            <th className="text-right font-medium pl-1 w-1/4">Pair</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-t border-gray-100 dark:border-gray-700">
            <td className="py-0.5 text-blue-600 dark:text-blue-400 font-medium truncate">Normal</td>
            <td className="py-0.5 text-right tabular-nums truncate">{normal.impair}</td>
            <td className="py-0.5 text-right tabular-nums truncate">{normal.pair}</td>
          </tr>
          <tr className="border-t border-gray-100 dark:border-gray-700">
            <td className="py-0.5 text-orange-600 dark:text-orange-400 font-medium truncate">Rattrap.</td>
            <td className="py-0.5 text-right tabular-nums truncate">{rattrap.impair}</td>
            <td className="py-0.5 text-right tabular-nums truncate">{rattrap.pair}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
